"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const codeComputeGetApphiveObject_1 = __importStar(require("../../shared/codeComputeGetApphiveObject"));
const Functions_1 = require("../../types/Functions");
const callableBuildCodeCompute = () => {
    const cacheOfFunctions = {};
    const getFunctionFromCache = (completeCode) => {
        if (!(0, ts_validators_1.valueIsString)(completeCode)) {
            throw new Error('Validation: Code is not a string');
        }
        const functionInCache = cacheOfFunctions[completeCode];
        if (functionInCache) {
            return functionInCache;
        }
        if (completeCode.includes('console.')) {
            throw new Error('Validation: Code cannot contain console.*');
        }
        if (completeCode.includes('require(')) {
            throw new Error('Validation: Code cannot contain require(');
        }
        if (completeCode.includes('import')) {
            throw new Error('Validation: Code cannot contain import');
        }
        if (completeCode.includes('export')) {
            throw new Error('Validation: Code cannot contain export');
        }
        if (completeCode.includes('process.')) {
            throw new Error('Validation: Code cannot contain process.*');
        }
        if (completeCode.includes('global.')) {
            throw new Error('Validation: Code cannot contain global.*');
        }
        if (completeCode.includes('window.')) {
            throw new Error('Validation: Code cannot contain window.*');
        }
        if (completeCode.includes('document.')) {
            throw new Error('Validation: Code cannot contain document.*');
        }
        if (completeCode.includes('fetch(')) {
            throw new Error('Validation: Code cannot contain fetch(');
        }
        if (completeCode.includes('XMLHttpRequest')) {
            throw new Error('Validation: Code cannot contain XMLHttpRequest');
        }
        if (completeCode.includes('alert(')) {
            throw new Error('Validation: Code cannot contain alert(');
        }
        if (completeCode.includes('await ')) {
            throw new Error('Validation: Code cannot contain await');
        }
        if (completeCode.includes('async ')) {
            throw new Error('Validation: Code cannot contain async');
        }
        if (completeCode.length > Functions_1.MAX_CHARACTERS_PER_CODE_COMPUTE) {
            throw new Error(`Validation: Code cannot be longer than ${Functions_1.MAX_CHARACTERS_PER_CODE_COMPUTE} characters`);
        }
        const wrappedCode = `
        const apphive = arguments[0]
        const codeComputeFunction = (args) => {
            ${completeCode}
        }
        return (args) => {
            const codeComputeResult = codeComputeFunction(args);
            return codeComputeResult
        };`;
        // eslint-disable-next-line no-new-func
        const codeComputeFunction = (new Function(wrappedCode));
        cacheOfFunctions[completeCode] = codeComputeFunction;
        return codeComputeFunction;
    };
    return ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.CODE]: code, [General_1.DEFINITION_PROP_NAMES.ARGS]: args, }, callbacks, functionId, executeProcesses, processor, }) => {
        try {
            (0, codeComputeGetApphiveObject_1.codeComputeSetFunctionCallbackById)(functionId, (key, params) => {
                executeProcesses(functionId, callbacks[key], params);
            });
            const codeFunction = getFunctionFromCache(code)((0, codeComputeGetApphiveObject_1.default)(functionId));
            return codeFunction(args);
        }
        catch (error) {
            const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
            processor.root.alert('codeCompute Error', `${errorMessage}`);
            return undefined;
        }
    };
};
exports.default = callableBuildCodeCompute;
